import { render, staticRenderFns } from "./IndCustomer.vue?vue&type=template&id=36cced86&"
import script from "./IndCustomer.vue?vue&type=script&lang=js&"
export * from "./IndCustomer.vue?vue&type=script&lang=js&"
import style0 from "./IndCustomer.vue?vue&type=style&index=0&id=36cced86&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports